export const ADD_LIST = "ADD_LIST";
export const ADD_MODAL_CREATE_LIST = "ADD_MODAL_CREATE_LIST";
export const ADD_ARTICLE_DETAIL = "ADD_ARTICLE_DETAIL";
export const ADD_MODAL_RENAME_LIST = "ADD_MODAL_RENAME_LIST";
export const ADD_MODAL_DELETE_LIST = "ADD_MODAL_DELETE_LIST";


// WEBPACK FOOTER //
// ./src/constants/ListConstants.js